import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { ResumeIcon } from '~/modules/common/components/Icons';
import { InnerAttachmentsBlock } from '~/modules/attachments/AttachmentsBlock/AttachmentsBlock';
import { CUSTOM_METADATA_BUILDER } from '~/modules/attachments/uploader/attachmentUtil';
import DelaAttachmentStatus from '~/modules/attachments/AttachmentsBlock/AttachmentsList/DelaAttachmentStatus';
import { useHasPermission } from '~/modules/common/permissions';
import { USER_DAL, USER_PERMISSION } from '~/modules/common/enums';
import useResumeHandlers from './useResumeHandlers';
import UploadResumeButton from './UploadResumeButton';
import ResumeCardUserHint from './ResumeCardUserHint';

export const title = <FormattedMessage id="resumeCard.resume" />;

export const avatarIcon = <ResumeIcon />;

export const acceptedFileTypes = [
  '.txt',
  '.pdf',
  '.doc',
  '.docx',
  '.odt',
  '.rtf'
];

const ResumeCard = ({ userUri, editable }) => {
  const {
    resume,
    isDialogOpen,
    onDialogOpen,
    onDialogClose,
    onFileUpload,
    isUploading,
    isLoading,
    error,
    deleteResume,
    enabledSourceUris
  } = useResumeHandlers({
    userUri,
    customMetadataFn: CUSTOM_METADATA_BUILDER.RESOURCE
  });

  const hasEditDocumentsPermission = useHasPermission({
    actionUri: USER_PERMISSION.EDIT_DOCUMENTS,
    dataAccessLevelUri: USER_DAL.USER
  });

  const userHintNode = hasEditDocumentsPermission ? (
    <ResumeCardUserHint />
  ) : null;

  return (
    <InnerAttachmentsBlock
      attachments={resume ? [resume] : []}
      onDialogOpen={onDialogOpen}
      onDialogClose={onDialogClose}
      isDialogOpen={isDialogOpen}
      attachToUri={userUri}
      deleteAttachment={deleteResume}
      editable={editable}
      onDialogOK={onFileUpload}
      error={error}
      isUploading={isUploading}
      isLoading={isLoading}
      enabledSourceUris={enabledSourceUris}
      title={title}
      AvatarIcon={avatarIcon}
      multiple={false}
      NewAttachmentButtonComponent={UploadResumeButton}
      acceptedFileTypes={acceptedFileTypes}
      fileTypeErrorMessageId="resumeCard.invalidFileTypeError"
      AttachmentStatusComponent={DelaAttachmentStatus}
      showDelaStarIcon
      userHintNode={userHintNode}
      noAttachmentsMessageId="resumeCard.noResume"
    />
  );
};

ResumeCard.propTypes = {
  userUri: PropTypes.string.isRequired,
  editable: PropTypes.bool.isRequired
};

export default memo(ResumeCard);
